module.exports = __webpack_public_path__ + "056a167e71c7fd8b8365d37734505e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./www/assets/sitios/agricolahimalaya/img/logos-detail.jpg
// module id = 691
// module chunks = 0